<template>
  <v-container justify-center pa-2 class="text-center">
    <h1>{{ $t('message.page_not_found') }}</h1>
    <icon-like size="400px" color="error"></icon-like>
  </v-container>
</template>

<script>
import IconLike from '@/components/displays/icons/IconLike2.vue';
export default {
  components: {
    IconLike
  }
}
</script>

<style scoped>
.rotate {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
</style>
